export default {
    title: 'Ready to launch your feedback cycle?',
    subtitle: 'Follow these steps to set up and launch your feedback cycle.',
    defineAudience: {
        stepTitle: 'Define Audience',
    },
    selectEvaluators: {
        stepTitle: 'Select Respondents',
    },
    templateSelection: {
        stepTitle: 'Choose a Template to Complete',
    },
    questionnaireCreation: {
        stepTitle: 'Build your Evaluation',
    },
    scheduleCreation: {
        stepTitle: 'Launch the Feedback Cycle',
    },
};
